// One scale for damage everywhere: 0 to 100, higher means more damage.
// These thresholds match InspectionDetailPage; every page uses this helper
// instead of its own cut-offs.
export const BANDS = {
  high: { key: 'high', label: 'Major', long: 'Major damage', min: 61 },
  med: { key: 'med', label: 'Moderate', long: 'Moderate damage', min: 41 },
  low: { key: 'low', label: 'Minor', long: 'Minor damage', min: 0 },
};

export function scoreBand(score) {
  if (score === null || score === undefined || Number.isNaN(Number(score))) return null;
  const s = Number(score);
  if (s > 60) return BANDS.high;
  if (s > 40) return BANDS.med;
  return BANDS.low;
}

// Finding-level severity from the backend: 'severe' | 'moderate' | 'minor'.
export function severityBand(severity) {
  const s = String(severity || '').toLowerCase();
  if (s === 'severe' || s === 'major' || s === 'high' || s === 'critical') return BANDS.high;
  if (s === 'moderate' || s === 'medium' || s === 'med') return BANDS.med;
  return BANDS.low;
}

// Workflow stage of an inspection, shared by the dashboard and inspection list.
// 'completed' in the backend means approved and locked by the landlord.
export function inspectionStage(insp) {
  if (insp?.status === 'completed') return 'approved';
  if (insp?.overall_score !== null && insp?.overall_score !== undefined) return 'review';
  return 'progress';
}

export function formatScore(score) {
  return score === null || score === undefined ? '--' : String(Math.round(Number(score)));
}
